let landbotInstance: any = null // referencia global dentro del módulo

export function setLandbotInstance(instance: any) {
  landbotInstance = instance
}

export function openLandbotChat() {
  if (landbotInstance) {
    landbotInstance.open()
  }
}

export function getLandbotInstance() {
  return landbotInstance
}
